import { render, staticRenderFns } from "./WebsiteUserRegistrationForm.vue?vue&type=template&id=0078bab0&scoped=true"
import script from "./WebsiteUserRegistrationForm.vue?vue&type=script&lang=js"
export * from "./WebsiteUserRegistrationForm.vue?vue&type=script&lang=js"
import style0 from "./WebsiteUserRegistrationForm.vue?vue&type=style&index=0&id=0078bab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0078bab0",
  null
  
)

export default component.exports